"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Placeholders = void 0;
const tslib_1 = require("tslib");
const catalog_messages_1 = require("@tableau/catalog-messages");
const SpotImageBaseIcon_1 = require("@tableau/icons/SpotImageBaseIcon");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const LabelDialogStyle_1 = require("./LabelDialogStyle");
const LabelsDialogContexts_1 = require("./LabelsDialogContexts");
const Editor = react_1.default.memo(() => {
    const message = catalog_messages_1.Messages.LabelsDialog_NoLabelSelected();
    return (react_1.default.createElement(LabelDialogStyle_1.LabelDialogBodySection, { width: 460, style: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
        } },
        react_1.default.createElement(SpotImageBaseIcon_1.SpotImageBaseIcon, { size: 60, alt: message }),
        react_1.default.createElement("div", null, message)));
});
const valueClass = (0, vizportalclient_common_components_1.cssClass)('value-placeholder', {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
});
const Value = react_1.default.memo(() => {
    const dispatch = (0, LabelsDialogContexts_1.useLabelDialogControlsDispatcher)();
    return (react_1.default.createElement("div", { className: valueClass },
        react_1.default.createElement("span", null, catalog_messages_1.Messages.LabelsDialog_ClearSearchInfo()),
        react_1.default.createElement("span", { style: { paddingTop: 24 } },
            react_1.default.createElement(widgets_1.ButtonWidget, { onClick: () => dispatch({ type: 'RESET_FILTER' }), buttonType: widgets_1.ButtonType.LowEmphasis },
                react_1.default.createElement("span", null, catalog_messages_1.Messages.LabelsDialog_ClearSearch())))));
});
exports.Placeholders = Object.freeze({ Editor, Value });
//# sourceMappingURL=Placeholders.js.map